export default "__VITE_ASSET__C3IX4mdv__"